import { CommonModule } from "@angular/common";
import { Component, effect, OnDestroy, OnInit, signal } from "@angular/core";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { OrderWizardService } from "../../_service/order-wizard.service";
import { PickupPointDto } from "../../../model/pickup-point.model";
import { debounceTime, distinctUntilChanged, startWith } from "rxjs";
import { PickupPointCardComponent } from "./card/pickup-point-card.component";
import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: 'order-wizard-pickup-point',
    imports: [CommonModule, ReactiveFormsModule, PickupPointCardComponent, TranslateModule],
    templateUrl: './order-wizard-pickup-point.component.html',
    styleUrls: ['./order-wizard-pickup-point.component.scss'],
    animations: []
})
export class OrderWizardPickupPointComponent implements OnInit, OnDestroy {
    form: FormGroup | null = null;
    searchControl = new FormControl('');
    selectedId: number | null = null;
    filteredPickupPoint: PickupPointDto[] = [];
    private readonly _searchSignal = signal('');
    isVisible = false;

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {
        this.form = this._orderWizardService.formGroup;

        this.filteredPickupPoint = this._orderWizardService.selection$()?.pickupPoint!;
        this.searchControl.valueChanges
            .pipe(
                startWith(''),
                debounceTime(100),
                distinctUntilChanged()
            ).subscribe(x => {
                this._searchSignal.set(this.searchControl.value || '')
            });

        effect(() => {
            this.updateFilteredPickupPoint();
        })
    }

    ngOnInit(): void {
        var selectedId = this._orderWizardService.orderWizard$()?.step02?.place?.id;
        this.selectedId = selectedId ?? null;
    }

    ngOnDestroy(): void {

    }

    toggleDropdown(toto: string) {

    }
                // opt.place?.code?.toLowerCase().includes(search.toLowerCase()) ||
    private updateFilteredPickupPoint() {
        const search = this._searchSignal();
        const selection = this._orderWizardService.selection$()?.pickupPoint;
        if (selection) {
            this.filteredPickupPoint = selection.filter(opt =>
                opt.place?.label?.toLowerCase().includes(search.toLowerCase()) ||
                opt.address?.city?.toLowerCase().includes(search.toLowerCase()) ||
                opt.address?.postalCode?.toLowerCase().includes(search.toLowerCase()) ||
                opt.address?.streetName?.toLowerCase().includes(search.toLowerCase()) ||
                opt.address?.state?.toLowerCase().includes(search.toLowerCase())
            )
        }
    }

    onSelectedIdChange($event: any){
        this._orderWizardService.changePickupPoint(this.getSelectedPickupPoint($event)!);
    }
    
    getSelectedPickupPoint(id: number | null): PickupPointDto | null {
        if (id === null) {
            return null;
        }
        const pickupPoints = this._orderWizardService.selection$()?.pickupPoint;
        return pickupPoints?.find(pp => pp.place?.id === id) || null;
    }



    

}